import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "Are your products really preservative-free?", a: "Yes. Everything at Nel Bake House is freshly baked with quality ingredients and no preservatives." },
  { q: "What are the Millet Cookies made of?", a: "Our Millet Cookies are made with wheat, ragi and millets — with No Maida, No White Sugar and No Oil." },
  { q: "Can I customize my brownies?", a: "Yes! Where available, brownies can be customized with a Wheat or Ragi base for an additional ₹100. Choose the option on the product page before adding to cart." },
  { q: "Where do you ship and how long does it take?", a: "We ship all over Karnataka. Delivery usually takes 6–7 days via DTDC and India Post." },
  { q: "What are the delivery charges?", a: "Delivery is charged at ₹70 per kg, calculated by the total weight of your order and shown at checkout." },
  { q: "Do you offer Cash on Delivery?", a: "No. We accept secure online payment only (UPI/QR). Your card or bank details are never stored by us." },
  { q: "How do I pay?", a: "At checkout you'll see our UPI ID and QR code. Pay using any UPI app, enter your payment reference (UTR), and we confirm your order once the payment is verified." },
  { q: "How do I track my order?", a: "Visit the Track Order page and enter your Order ID (e.g. NBH-10482) along with the phone number used at checkout. Courier and AWB details appear there once dispatched." },
  { q: "What are your business hours?", a: "We're available from 9 AM to 8 PM. You can also reach us anytime via the Need Help? button." },
];

const FAQ = () => (
  <div className="mx-auto max-w-3xl px-5 sm:px-8 py-14 sm:py-20">
    <div className="text-center mb-10">
      <p className="text-goldsoft text-xs uppercase tracking-[0.3em] mb-2">Need Help?</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-choco">Frequently Asked Questions</h1>
    </div>
    <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl border border-[#EFEBE1] px-5">
          <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-semibold text-choco hover:no-underline">{f.q}</AccordionTrigger>
          <AccordionContent className="text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
);

export default FAQ;
